<div [class.rtl]="currLang == 'ar'" class="modal" id="studentAttendanceReport" tabindex="-1" data-backdrop="static"
    data-keyboard="false">
    <div class="modal-dialog">
        <div class="modal-content">
            <div *ngIf="loading" class="loading">
                <mat-spinner *ngIf="true" mode="indeterminate"></mat-spinner>
            </div>
            <div class="modal-header">
                <h5 class="modal-title">{{'student-attendance.header' | translate}}</h5>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div class="modal-body">
                <div id="report-card-modal" class="student-attendance-report-container">
                    <div class="student-attendance-report-container-header">
                        <div class="student-info">
                            <img class="student-info-image" [src]="getImage()" alt="">
                            <span class="student-info-label">{{studentName}}</span>
                        </div>
                        <div [ngClass]="currLang === 'en'?'student-control-bar':'student-control-bar-Ar'">
                            <app-reports-control-bar (finishedLoading)="finishedLoading()" [controlType]="'single-log'" [hideFilter]="true" [hideFilterTag]="true" >
                            </app-reports-control-bar>
                        </div>
                    </div>
                    <div class="student-attendance-report-container-body">
                        <div class="student-attendance-report-container-body-list">
                            <app-table-view [controls]="tableControls" (eventHandeler)="tableEventHandeler($event)">
                            </app-table-view>
                        </div>
                        <div class="full-report">
                            <div class="full-report-header">
                                <label>{{'student-attendance.full-attendance' | translate}}</label>
                            </div>
                            <div class="full-report-body">
                                <div>
                                    <span>{{'student-attendance.presence' | translate}}</span>
                                    <span>{{presentCount}}</span>
                                </div>
                                <div>
                                    <span>{{'student-attendance.absence' | translate}}</span>
                                    <span>{{absentCount}}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>